document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-nav-toggle]').forEach(function(btn){btn.addEventListener('click',function(){var nav=document.querySelector('[data-nav]');if(nav)nav.classList.toggle('open')})});
  document.querySelectorAll('.faq-q').forEach(function(q){q.addEventListener('click',function(){q.parentElement.classList.toggle('open')})});
  document.querySelectorAll('[data-gallery-filter]').forEach(function(btn){btn.addEventListener('click',function(){var f=btn.dataset.galleryFilter;document.querySelectorAll('[data-gallery-filter]').forEach(function(b){b.classList.remove('active')});btn.classList.add('active');document.querySelectorAll('[data-gallery-category]').forEach(function(el){el.style.display=(f==='all'||el.dataset.galleryCategory===f)?'':'none'})})});
});

(function(){
  function initHeroSliders(){
    document.querySelectorAll('[data-hero-slider]').forEach(function(slider){
      var slides=[].slice.call(slider.querySelectorAll('[data-hero-slide]'));
      if(slides.length<2) return;
      var dots=[].slice.call(slider.querySelectorAll('[data-hero-dot]'));
      var prev=slider.querySelector('[data-hero-prev]');
      var next=slider.querySelector('[data-hero-next]');
      var index=0;
      var autoplay=slider.getAttribute('data-autoplay')==='true';
      var speed=parseInt(slider.getAttribute('data-speed')||5000,10);
      var timer=null;
      function show(i){
        index=(i+slides.length)%slides.length;
        slides.forEach(function(s,n){s.classList.toggle('is-active',n===index)});
        dots.forEach(function(d,n){d.classList.toggle('is-active',n===index)});
      }
      function start(){ if(autoplay){ stop(); timer=setInterval(function(){show(index+1)}, speed); } }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }
      if(prev) prev.addEventListener('click',function(){show(index-1);start()});
      if(next) next.addEventListener('click',function(){show(index+1);start()});
      dots.forEach(function(dot){dot.addEventListener('click',function(){show(parseInt(dot.getAttribute('data-hero-dot'),10)||0);start()})});
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      show(0); start();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initHeroSliders); else initHeroSliders();
})();


(function(){
  function initQuoteModal(){
    var modal=document.querySelector('[data-quote-modal]');
    if(!modal) return;
    function openModal(e){
      if(e) e.preventDefault();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('quote-modal-open');
      var first=modal.querySelector('input,textarea,button');
      if(first) setTimeout(function(){first.focus()},60);
    }
    function closeModal(e){
      if(e) e.preventDefault();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('quote-modal-open');
    }
    document.querySelectorAll('[data-open-quote-modal], a[href="#quote-modal"], a[href="#quote-form"]').forEach(function(el){el.addEventListener('click',openModal)});
    modal.querySelectorAll('[data-close-quote-modal]').forEach(function(el){el.addEventListener('click',closeModal)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('is-open')) closeModal(e)});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initQuoteModal); else initQuoteModal();
})();

(function(){
  function initV18Menus(){
    document.querySelectorAll('[data-submenu-toggle]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        var item=btn.closest('.nav-item');
        if(!item) return;
        var nav=item.closest('.nav');
        if(nav){
          nav.querySelectorAll('.nav-item.is-open').forEach(function(other){
            if(other!==item){
              other.classList.remove('is-open');
              var otherBtn=other.querySelector('[data-submenu-toggle]');
              if(otherBtn) otherBtn.setAttribute('aria-expanded','false');
            }
          });
        }
        item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('.nav-item')){
        document.querySelectorAll('.nav-item.is-open').forEach(function(item){
          item.classList.remove('is-open');
          var btn=item.querySelector('[data-submenu-toggle]');
          if(btn) btn.setAttribute('aria-expanded','false');
        });
      }
    });
  }
  function syncGalleryFilterPills(){
    var sections=[].slice.call(document.querySelectorAll('.gallery-category-section[data-gallery-category], .gallery-row[data-gallery-category]'));
    if(!sections.length) return;
    var cats={};
    sections.forEach(function(section){
      var cat=section.getAttribute('data-gallery-category');
      if(cat) cats[cat]=true;
    });
    document.querySelectorAll('[data-gallery-filter]').forEach(function(btn){
      var value=btn.getAttribute('data-gallery-filter');
      if(value && value!=='all' && !cats[value]) btn.hidden=true;
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initV18Menus();syncGalleryFilterPills();});
  }else{
    initV18Menus();syncGalleryFilterPills();
  }
})();
